import type { AttributeObject } from '@djust-b2b/djust-front-sdk/lib/interfaces/models/attribute.js';
import type { ProductGetters } from './types';

export function useProductGetters(): ProductGetters {
  const getProductId = (product: Product): string => {
    return product?.id;
  };

  const getProductStatus = (product: Product): string => {
    return product?.productStatus;
  };

  const getProductAttributeValues = (product: Product): ProductAttributeValue[] => {
    return product?.attributeValues;
  };

  const getProductAttributeValuebyExternalId = (product: Product, externalId: string): string => {
    const attributeValue = product.attributeValues.find(
      (attributeValue: AttributeObject) => attributeValue.attribute?.externalId === externalId
    );
    return attributeValue ? attributeValue?.value : null;
  };

  const getMainProductPictureUrls = (product: Product): MediaInfoDTO[] | null => {
    const mainPicture = product.productPictures.find((picture) => picture.isMain);
    return mainPicture ? mainPicture.urls : null;
  };

  const getProductPictures = (product: Product): MediaInfoDTO[] => {
    return product?.productPictures;
  };

  const getProductTags = (product: Product): string[] | undefined => {
    return product.tags?.map((tag) => tag.name);
  };

  const getProductExternalId = (product: Product): string | undefined => {
    return product?.externalId;
  };

  const getProductExternalSource = (product: Product): string | undefined => {
    return product?.externalSource;
  };

  const getProductName = (product: Product): string => {
    return product?.info?.name;
  };

  const getProductDescription = (product: Product): string => {
    return product?.info?.description;
  };

  const getProductBrand = (product: Product): string => {
    return product?.info?.brand;
  };

  const getProductSku = (product: Product): string => {
    return product?.info?.sku;
  };

  const getProductUnitType = (product: Product): string => {
    return product?.info?.unit?.type;
  };

  const getProductUnitUnit = (product: Product): string => {
    return product?.info?.unit?.unit;
  };

  const getRelatedProductsList = (relatedProducts: RelatedProductsList): RelatedProduct[] => {
    return relatedProducts?.productThumbnails?.content;
  };
  return {
    getProductId,
    getProductSku,
    getProductStatus,
    getProductBrand,
    getProductAttributeValues,
    getProductUnitType,
    getProductUnitUnit,
    getMainProductPictureUrls,
    getProductTags,
    getProductExternalId,
    getProductExternalSource,
    getProductName,
    getProductDescription,
    getProductPictures,
    getProductAttributeValuebyExternalId,
    getRelatedProductsList,
  };
}
